import * as React from 'react';
import {View} from 'react-native';
import {ProductsAcceptorFilterViewBaseProps} from '../../../model';
import {useStyles} from '../../../../../../shared/hooks/styles';
import {CustomScrollView} from '../../../../../../shared/components/scrollView';
import {ProductAcceptorFilterList} from '../../list';
import {AccordionRewardShop} from '../../../../Accordion';

export const ProductsAcceptorFilterDesktop: React.FC<ProductsAcceptorFilterViewBaseProps> = ({productAcceptors}) => {
  const styles = useStyles(({theme, addShadow}) => ({
    wrapper: {
      width: `100%`,
      position: 'relative',
      zIndex: 0,
    },
    activateButton: {
      width: `100%`,
      color: 'red',
    },
    filterPanel: {
      position: 'absolute',
      right: 0,
      zIndex: 100,
      top: 60,
      width: 300,
      backgroundColor: theme.color.primaryNonGreyBackground,
      paddingTop: 0,
      ...addShadow({
        height: 8,
        radius: 25,
        opacity: 0.1,
      }),
      borderRadius: 5,
    },
    filterScrollContainer: {
      maxHeight: 330,
    },
    filterScrollContentContainer: {
      paddingVertical: 20,
      paddingLeft: 20,
    },
    filterButtonContainer: {
      paddingVertical: 12,
      paddingHorizontal: 20,
      alignItems: 'center',
      borderTopWidth: 0,
      borderStyle: 'solid',
      borderTopColor: theme.color.borderColor,
    },
    filterButton: {
      width: 200,
    },
  }));

  return (
    <View style={styles.wrapper}>
      <View style={{width: '100%'}}>
        <AccordionRewardShop title='Партнеры' accordionId='acceptorAccordion'>
          <CustomScrollView
            contentContainerStyle={styles.filterScrollContentContainer}
            style={styles.filterScrollContainer}
            {...{dataSet: {class: 'custom-scroll'}}}>
            <ProductAcceptorFilterList productAcceptors={productAcceptors} />
          </CustomScrollView>
        </AccordionRewardShop>
      </View>
    </View>
  );
};
